export const TEST_ID = 'stepperInput';

export const DECREMENT_BUTTON_TEST_ID = 'stepperInputDecrementButton';

export const INCREMENT_BUTTON_TEST_ID = 'stepperInputIncrementButton';

export const VALUE_INPUT_TEST_ID = 'stepperInputValue';

export const DEFAULT_STEP = 1;
